import { theme } from '@aloft/toolkit-sui';

type GridLineProps = { x1: number; x2: number; y1: number; y2: number; index: number; key: string };

export const makeGridLineVertical = (lastIndex: number) => {
  const GridLineVertical = (props: unknown) => {
    const { x1, x2, y1, y2, index } = props as GridLineProps;
    if (index === 0 || index === lastIndex) return <g />;
    return <line x1={x1} x2={x2} y1={y1} y2={y2} stroke={theme.colors.strokeLight} strokeDasharray="3 3" />;
  };
  return GridLineVertical;
};

export const makeGridLineHorizontal = (plotTop: number, plotBottom: number) => {
  const GridLineHorizontal = (props: unknown) => {
    const { x1, x2, y1, y2 } = props as GridLineProps;
    if (y1 <= plotTop || y1 >= plotBottom) return <g />;
    return <line x1={x1} x2={x2} y1={y1} y2={y2} stroke={theme.colors.strokeLight} strokeDasharray="3 3" />;
  };
  return GridLineHorizontal;
};
